import axios, { CanceledError } from 'axios';
import MenuStructure from './MenuStructure';

function useMenuProvider(baseUrl: string) {
    async function getMenuItems(): Promise<MenuStructure> {
        try {
            const response = await axios.get<MenuStructure>(baseUrl + '/api/common/content/menu', { timeout: 2000 });

            return response.data;
        } catch (e) {
            if (!(e instanceof CanceledError)) {
                console.log(e);
            }
            throw e;
        }
    }

    return {
        getMenuItems
    };
}

export default useMenuProvider;
